import React from 'react';
import {
  Box, Typography, makeStyles, Paper,
} from '@material-ui/core';
import InfoIcon from '../../../assets/img/marketPlace/InfoIcon.svg';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    padding: theme.spacing(2),
  },
  warningCard: {
    backgroundColor: theme.body.warningLicenseAssignment.backgroundColor,
    borderRadius: '20px',
    padding: theme.spacing(5),
    textAlign: 'center',
    maxWidth: '608px',
    height: '272px',
    width: '100%',
    boxShadow: `0px 10px 25px ${theme.body.warningLicenseAssignment.boxShadow}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    width: '80px',
    height: '80px',
    marginBottom: theme.spacing(4),
  },
  title: {
    fontWeight: 700,
    color: theme.body.warningLicenseAssignment.title,
    fontSize: '28px',
    marginBottom: theme.spacing(2),
    fontFamily: '"Karla"',
  },
  description: {
    color: theme.body.warningLicenseAssignment.description,
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '1.6',
    textAlign: 'center',
    fontFamily: '"Karla"',
  },
}));

const LicenseAssignment = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Paper elevation={0} className={classes.warningCard}>
        <img
          src={InfoIcon}
          alt="warning icon"
          className={classes.icon}
        />
        <Typography variant="h2" className={classes.title}>
          ¡Oh oh!
        </Typography>
        <Typography className={classes.description}>
          Ya asignaste todos los productos de esta compra.
        </Typography>
      </Paper>
    </Box>
  );
};

export default LicenseAssignment;
